import media from "styles/media"
import text from "styles/text"
import styled from "styled-components"
import { useMemo } from "react"
import { checkedLocaleLink } from "utils/routes"
import SeafoamLine from "components/buttons/SeafoamLine"
import { LocaleData } from "types/gatsby-alias";
import { useI18next } from "gatsby-plugin-react-i18next"
import { Section } from "components/Header"

interface Link {
  title: string;
  url: string;
}

interface FeaturedProductProps {
  links: Section;
  title: string;
  translation: LocaleData;
  languageOverride?: string;
}

export default function FeaturedProduct({
    links,title,translation,languageOverride
  }:FeaturedProductProps
) {
    const { language } = useI18next();    
    const featuredLink:Link = links.links[0];
    
    const Emoji = ({title}:{title:string})=>{
        if(title==='Cyberbank Core'||title==='Cyberbank Digital'){
            return <span role="img" aria-label="bank">🏦</span>
        }
        else if(title==='Card Issuing'){
            return <span role="img" aria-label="card">💳</span>;
        }
        else if(title==='Secured Credit'){
            return <span role="img" aria-label="lock">🔒</span>;
        }
        else if(title==='Instant Verification Engine'){
            return <span role="img" aria-label="risk">✅</span>;
        }
        else if(title==='Sandbox'){
            return <span role="img" aria-label="puzzle">🧩</span>;
        }
        else if(title==='Podcast'){
            return <span role="img" aria-label="podcast">🎤</span>;
        }
        return <></>
    }
    const allLinks = useMemo(
        () =>{
            const localeLink = checkedLocaleLink(
                featuredLink.url,
                languageOverride ?? language,
            )
            
            return (
                <SeafoamLine href={localeLink} key={featuredLink.title}>
                    <Emoji title={featuredLink.title}/>
                    <span>&nbsp;&nbsp;</span>
                {translation[featuredLink.title]}
              </SeafoamLine>
            )
        }
          ,
        [featuredLink, translation, language, languageOverride]
      )
    return <>
        <FeaturedProductContainer>
            <FeaturedProductTitle>{title=="Platform"||title=="Company"?translation['Featured']:translation['Featured Product']}</FeaturedProductTitle>
            <FeaturedProductLink>
                {allLinks}
            </FeaturedProductLink>
        </FeaturedProductContainer>
    </>

  }

  const FeaturedProductContainer = styled.div`
  ${media.fullWidth} {
    margin-bottom: 50px;
    margin-top: 25px;
  }
  ${media.tablet} {
    margin-bottom: 4.883vw;
    margin-top: 2.441vw;
   
  }
  margin-bottom: 3.012vw;
  margin-top: 1.506vw;
  
  background-color:#080F4D;
  border-radius:10px;
  display: flex;
  flex-direction: column;
`
const FeaturedProductTitle = styled.h6`
  ${media.fullWidth} {
    margin: 25px;
  }
  ${media.tablet} {
    margin: 2.883vw;
   
  }
  margin: 1.512vw;
  color: #ffffff;
  ${text.h6}
  font-size: 18px;
  ${media.desktop} {
    font-size: 1.226vw;
  }
  ${media.tablet} {
    font-size: 2.044vw;
  }
  ${media.mobile} {
    font-size: 5.9vw;
  }
`
const FeaturedProductLink = styled.div`
  ${media.fullWidth} {
    margin: 25px;
    margin-top:0;
  }
  ${media.tablet} {
    margin: 2.883vw;
    margin-top:0;
  }
  margin: 1.512vw;
  margin-top:0;
`